var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"letter-spawner",staticClass:"letter-spawner"},_vm._l((Array.range(this.config.spawnerCount, 0)),function(number,index){return _c('v-letter',{key:index,attrs:{"index":index,"config":_vm.config},on:{"status":_vm.changeStatus}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }